import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import { ErpWarehouseService } from '../../../services/erp/erp-warehouse.service';

@Component({
  selector: 'app-product-warehouse-stock-info',
  standalone: true,
  imports: [
    MatListModule,
    MatTable,
    MatHeaderCell,
    MatCell,
    TranslatePipe,
    MatHeaderRow,
    MatRow,
    MatColumnDef,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRowDef,
    MatRowDef,
  ],
  templateUrl: './product-warehouse-stock-info.component.html',
  styleUrl: './product-warehouse-stock-info.component.css',
})
export class ProductWarehouseStockInfoComponent implements OnInit {
  protected readonly window = window;
  data = inject(MAT_DIALOG_DATA).line;
  productName = inject(MAT_DIALOG_DATA).productName;
  private readonly erpWarehouseService = inject(ErpWarehouseService);
  productStocksPerWarehouse =
    this.erpWarehouseService.productStocksPerWarehouse;
  warehouseProductStocks = this.erpWarehouseService.warehouseProductStocks;
  displayedColumns: string[] = ['title', 'stock'];
  warehouseName = '';

  ngOnInit() {
    this.fetchInformation();
  }

  private fetchInformation() {
    this.erpWarehouseService.fetchProductStockInfo(this.data.product_id);
    if (this.data.warehouse_id) {
      this.warehouseName = this.erpWarehouseService.fetchWarehouseName(
        this.data.warehouse_id
      );
      this.erpWarehouseService.fetchWarehouseProductStocks(
        this.data.warehouse_id
      );
    }
  }
}
